import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { HeaderComponent } from './components/header/header.component';
import { BannerComponent } from './components/banner/banner.component';
import { FooterComponent } from './components/footer/footer.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    SidebarComponent,
    HeaderComponent,
    BannerComponent,
    FooterComponent,
  ],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  @HostListener('window:resize')
  onResize() {
    const windowWidth = window.innerWidth;
    const shouldShowWidth = windowWidth >= 900;

    if (shouldShowWidth !== this.isShowMenu) {
      this.isShowMenu = shouldShowWidth;
      this.isMob = !shouldShowWidth;
    }
  }
  protected isShowMenu = true;
  protected isMob = false;

  constructor() {
    const windowWidth = window.innerWidth;
    this.isMob = windowWidth <= 900;
    this.isShowMenu = !this.isMob;
  }

  protected toggle(action: 'changeCategory' | 'menuToggle') {
    if (action === 'changeCategory' && !this.isMob) {
      return;
    }
    this.isShowMenu = !this.isShowMenu;
  }
}
